<div class="obg-m-entity-legal-notice-container">
	<h2
		class="obg-m-entity-legal-notice-container-title"
		[innerHtml]="'group-companies.entity-legal-notice-title' | translate"
	></h2>
	<article
		class="obg-m-entity-legal-notice-container-content"
		[innerHtml]="legalNoticeTranslationKey  | translate"
	></article>
	<div class="obg-m-entity-legal-notice-container-options">
		<button
			mat-button
			[ngClass]="{'mat-flat-button': isDesktop}"
			color="primary"
			test-id="entity-legal-notice-accept"
			(click)="accept()"
		>
			{{ 'group-companies.entity-legal-notice-accept' | translate }}
		</button>
	</div>
</div>
